export default __webpack_public_path__ + "chironton71-black.png";